import { TopbarContextType } from '../../types'
import { TopbarNavItem } from './types'

interface NavLinks {
  home: TopbarNavItem
  consultaProcessual: TopbarNavItem
  jurisprudencia: TopbarNavItem
  doutrina: TopbarNavItem
  artigos: TopbarNavItem
  noticias: TopbarNavItem
  diarios: TopbarNavItem
  pecas: TopbarNavItem
  modelosPecas: TopbarNavItem
  legislacao: TopbarNavItem
  advogados: TopbarNavItem
}

export function mountNavItems(
  isLogged?: boolean,
  flags?: TopbarContextType['flags'],
  // Prefix for the relative nav links. Empty by default so links stay
  // origin-relative (correct on www.jusbrasil.com.br and on staging/preview
  // hosts). Apps rendered off the www origin (e.g. per-user subdomains) can
  // pass the canonical base URL so the links point back to www.
  baseUrl = ''
): TopbarNavItem[] {
  const { shouldShowJusIABasedOnCurrentSubscription } = flags || {}

  const pageLinks: NavLinks = {
    home: { title: isLogged ? 'Para você' : 'Home', url: `${baseUrl}/`, key: 'HOME' },
    consultaProcessual: {
      title: 'Consulta processual',
      url: `${baseUrl}/consulta-processual`,
      key: 'CONSULTA_PROCESSUAL',
    },
    jurisprudencia: {
      title: 'Jurisprudência',
      url: `${baseUrl}/jurisprudencia`,
      key: 'JURISPRUDENCIA',
    },
    doutrina: { title: 'Doutrina', url: `${baseUrl}/doutrina`, key: 'DOUTRINA' },
    artigos: { title: 'Artigos', url: `${baseUrl}/artigos`, key: 'ARTIGOS' },
    noticias: { title: 'Notícias', url: `${baseUrl}/noticias`, key: 'NOTICIAS' },
    diarios: { title: 'Diários', url: `${baseUrl}/diarios`, key: 'DIARIOS' },
    pecas: { title: 'Peças Processuais', url: `${baseUrl}/pecas`, key: 'PECAS' },
    modelosPecas: { title: 'Modelos', url: `${baseUrl}/modelos-pecas`, key: 'MODELOS' },
    legislacao: { title: 'Legislação', url: `${baseUrl}/legislacao`, key: 'LEGISLACAO' },
    advogados: { title: 'Diretório de Advogados', url: `${baseUrl}/advogados`, key: 'ADVOGADOS' },
  }

  const defaultLinks: TopbarNavItem[] = Object.keys(pageLinks)
    .map((key) => pageLinks[key as keyof NavLinks])
    .filter((item) => !!item)

  if (shouldShowJusIABasedOnCurrentSubscription) {
    const newsIndex = defaultLinks.findIndex((item) => item.key === 'NOTICIAS')
    if (newsIndex !== -1) {
      defaultLinks.splice(newsIndex, 1)
    }
    const jurisprudenceIndex = defaultLinks.findIndex((item) => item.key === 'JURISPRUDENCIA')
    if (jurisprudenceIndex !== -1) {
      defaultLinks.splice(jurisprudenceIndex + 1, 0, {
        url: 'https://ia.jusbrasil.com.br',
        title: 'Jus IA',
        key: 'JUS_IA',
      } as TopbarNavItem)
    }
  }

  return defaultLinks
}
